/**
 * 设备类型映射：旧 EquipmentType（PascalCase）↔ 新 classEnumId（IT_EC_*）
 * ------------------------------------------------------------------
 * 旧系统设备类型是扁平字符串（Server/Network/Unix/Mysql...，20+ 种），
 * 新接口用 OFBiz 枚举 classEnumId（IT_EC_SERVER/IT_EC_SWITCH...，9 大类）。
 * 多个旧子类型映射到同一新大类。
 */

// 旧 EquipmentType → 新 classEnumId
const TYPE_TO_CLASS = {
  // 服务器类
  Server: 'IT_EC_SERVER', Unix: 'IT_EC_SERVER', Windows: 'IT_EC_SERVER',
  SNMPUnix: 'IT_EC_SERVER', SNMPWindows: 'IT_EC_SERVER', IPMIServer: 'IT_EC_SERVER',
  // 网络设备类
  Network: 'IT_EC_SWITCH', CheckPoint: 'IT_EC_SWITCH', Netscreen: 'IT_EC_SWITCH', TOPSEC: 'IT_EC_SWITCH',
  WirelessNetwork: 'IT_EC_SWITCH',
  // 数据库类
  DataBase: 'IT_EC_DATABASE', SqlServer: 'IT_EC_DATABASE', Mysql: 'IT_EC_DATABASE', Oracle: 'IT_EC_DATABASE', Postgresql: 'IT_EC_DATABASE',
  // 存储类
  Storage: 'IT_EC_STORAGE', EMCStorage: 'IT_EC_STORAGE', IBMStorage: 'IT_EC_STORAGE',
  // 防火墙
  FireWall: 'IT_EC_FIREWALL',
  // 虚拟机
  VirtualMachine: 'IT_EC_VM', VMware: 'IT_EC_VM',
  // 中间件/应用系统
  MiddleWare: 'IT_EC_SERVER', ApplicationSystem: 'IT_EC_SERVER',
  // 机房环境
  ComputerRoomEnvironment: 'IT_EC_OTHER',
  Emerson: 'IT_EC_OTHER', Raritan: 'IT_EC_OTHER', Santakups: 'IT_EC_OTHER',
  DME3000: 'IT_EC_OTHER', APEM6100: 'IT_EC_OTHER', LiebertCorp: 'IT_EC_OTHER',
  // 其它
  WebSite: 'IT_EC_OTHER', MailSystem: 'IT_EC_OTHER', LoadBalancing: 'IT_EC_OTHER',
  BatteryPack: 'IT_EC_OTHER',
};

// 新 classEnumId → 旧默认 EquipmentType（反向映射，用于回填时的兜底）
const CLASS_TO_TYPE = {
  IT_EC_SERVER: 'Server',
  IT_EC_SWITCH: 'Network',
  IT_EC_ROUTER: 'Network',
  IT_EC_FIREWALL: 'FireWall',
  IT_EC_STORAGE: 'Storage',
  IT_EC_VM: 'VirtualMachine',
  IT_EC_PRINTER: 'Other',
  IT_EC_UPS: 'Other',
  IT_EC_OTHER: 'Other',
  IT_EC_DATABASE: 'DataBase',
  IT_EC_WIRELESS: 'WirelessNetwork',
};

/**
 * 旧 EquipmentType → 新 classEnumId
 * @param {string} equipmentType 旧类型，如 'Server'/'Mysql'
 * @returns {string} classEnumId，如 'IT_EC_SERVER'；未匹配兜底 'IT_EC_OTHER'
 */
export function equipmentTypeToClassEnum(equipmentType) {
  if (!equipmentType) return 'IT_EC_OTHER';
  return TYPE_TO_CLASS[equipmentType] || 'IT_EC_OTHER';
}

/**
 * 新 classEnumId → 旧 EquipmentType（回填兜底用）
 * @param {string} classEnumId 如 'IT_EC_SERVER'
 * @returns {string} 旧类型，如 'Server'
 */
export function classEnumToEquipmentType(classEnumId) {
  if (!classEnumId) return '';
  return CLASS_TO_TYPE[classEnumId] || '';
}
